


























































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import Info from './components/Info.vue';
import BaseListModal from './components/BaseListModal.vue';

import moment from 'moment';
import axios from 'axios';

@Component({
    components: {
        Info,
        BaseListModal,
    },
})
export default class PrimaryList extends Vue {

    private loading: boolean = false;

    private moment: any = moment;

    private baselistmodal: boolean = false;

    private newRecoard: any = {};

    private paginationProps: any = {
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 5,
        total: 50,
    };

    private list: any[] = [];

    private showModal() {
      this.baselistmodal = true;
    }

    private mounted() {
        axios.get('/api/fake_list', {
            params: {
                count: 5,
            },
        }).then((res: any) => {
            this.list = res.data;
            // console.log(this.list);
        });
    }

    private handleEditClick(e: any, item: any): void {
      e.preventDefault();
      // console.log(item);
      this.showEditModal(item);
    }

    private handleEditAndDelete(key: any, item: any): void {
      // console.log(key);
      // console.log(item);
      this.showEditModal(item);
    }

    private newModal(): void {
      this.baselistmodal = true;
      this.newRecoard = {};
    }

    private showEditModal(item: any): void {
      this.baselistmodal = true;
      this.newRecoard = item;
      // console.log(item);
    }

    private handleSearch(value: any) {
      // console.log(value);
    }

    private handleListModalClose(isok: any) {
      // console.log('handleListModalClose');
      // console.log('isok', isok);
    }
}
